// SurveyModal.jsx
import React from "react";
import "./CSS/SurveyModal.css";

export default function SurveyModal({
  surveyData,
  setSurveyData,
  onClose,
  onSubmit,
}) {
  return (
    <div className="summary-modal-overlay" onClick={onClose}>
      <div className="summary-modal survey" onClick={e => e.stopPropagation()}>
        <h2>Quick 30-sec survey</h2>

        {[
          "I found today’s AI feedback helpful and easy to act on.",
          "The system felt supportive and respectful in how it gave feedback.",
          "I felt confident applying the coaching strategy in today’s activity.",
        ].map((label, i) => (
          <div key={i} className="survey-block">
            <p>{label}</p>
            <div className="emoji-row">
              {[1, 2, 3, 4, 5].map(v => (
                <button
                  key={v}
                  className={`emoji-btn ${surveyData[`q${i + 1}`] === v ? "selected" : ""}`}
                  onClick={() => setSurveyData(d => ({ ...d, [`q${i + 1}`]: v }))}
                >
                  {["😞", "😕", "😐", "🙂", "😊"][v - 1]}
                </button>
              ))}
            </div>
          </div>
        ))}

        <div className="survey-block">
          <p>I changed something in how I interacted with my child based on the previous feedback.</p>
          <div className="choice-row">
            {["yes", "no", "maybe"].map(v => (
              <button
                key={v}
                className={`choice-btn ${surveyData.q4 === v ? "selected" : ""}`}
                onClick={() => setSurveyData(d => ({ ...d, q4: v }))}
              >
                {v}
              </button>
            ))}
          </div>
        </div>

        <div className="survey-block">
          <p>Was there anything confusing or unclear about today’s feedback?</p>
          <textarea
            rows={3}
            value={surveyData.q5}
            onChange={e => setSurveyData(d => ({ ...d, q5: e.target.value }))}
          />
        </div>

        <button
          className="modal-submit-btn"
          disabled={!surveyData.q1 || !surveyData.q2 || !surveyData.q3 || !surveyData.q4}
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
